import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingOutlined } from "@ant-design/icons";
import { Image, Spin } from "antd";
import {
  getMerchantAddress,
  getMerchantSetting,
  getMerchantPages,
} from "apiServices/app";
import HomeImage from "assets/images/homejpg.jpg";
import BackgroundVideo from '../../ECBasic/ECHeroSectionComponent/BackgroundVideo';
import { CryptoPassword, encryptedText } from "utils/crypto";
import { baseImageURL } from "utils/env";
import { EcommerceFlow, toastMessage, useGlobalMerchant } from 'utils/helper';
import MSubRoutesComponent from 'components/MerchantSubRoutes/MSubRoutesComponent';
import ECProductComponent from "components/Ecommerce/ECProductComponent";
import ECAddressWrapperComponent from '../../ECAddressWrapperComponent';
import ECFooterComponent from '../../ECLayout/ECFooterComponent';
import ECHeaderComponent from '../../ECLayout/ECHeaderComponent';
import { useBasket } from "containers/POSContainer/constant";
import { useStyles } from './style';

const ECAdvanceComponent = () => {
  const classes = useStyles();
  const { globalMerchantId, ecommerceContent, isEndsWithSlash } = useGlobalMerchant();
  const [showShippingLayout, setShowShippingLayout] = useState(false);
  const [showSideBasket, setShowSideBasket] = useState(false);
  const [pagesContent, setPagesContent] = useState<any>({});
  const [merchantContent, setMerchantContent] = useState<any>({});
  const [chainList, setChainList] = useState<any>([]);

  const itemlist = useBasket();

  let length = 0;
  if (itemlist && itemlist.itemList) { length = itemlist.itemList.length; }

  function getFileType(filePath: string): "image" | "video" {
    const isVideo = filePath.toLowerCase().endsWith(".mp4");
    return isVideo ? "video" : "image";
  }

  const manageBgDetails = (getPath: any) => {
    if (getPath == null) {
      return <Image src={HomeImage} alt="background image" preview={false} />;
    } else {
      const fileType = getFileType(getPath);
      if (fileType === "image") {
        return <Image src={`${baseImageURL}${getPath}`} alt="background image" preview={false} />;
      } else {
        const videoSource = `${baseImageURL}${getPath}`;
        return <BackgroundVideo videoSource={videoSource}></BackgroundVideo>;
      }
    }
  };

  const onGetMerchantAddress = (getMerchantId: any) => {
    try {
      getMerchantAddress(getMerchantId)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData.length > 0) {
            const activeNetworks = responseData.filter((network: any) => network.is_active === 1);
            setChainList(activeNetworks.reverse());
          } else {
            toastMessage("You don't have blockchain profile");
          }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  };

  const onGetMerchantPages = (getMerchantKey: any) => {
    try {
      getMerchantPages(getMerchantKey)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            setPagesContent(responseData);
          }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  }

  const onGetMerchantDetails = (getUserKey: any) => {
    try {
      getMerchantSetting(getUserKey)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            if (responseData && responseData.success == false) {
              toastMessage("You dont have any profile");
            } else {
              onGetMerchantPages(responseData.merchant_id);
              onGetMerchantAddress(responseData.merchant_id);
              setMerchantContent(responseData);
              localStorage.setItem("ec-email", encryptedText(CryptoPassword, responseData.merchant_email));
            }
          }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  };

  useEffect(() => {
    onGetMerchantDetails(globalMerchantId);
  }, []);

  return (
    <>
      {Object.keys(merchantContent).length == 0 ? (
        <div className="loaderCenterWrapper">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      ) : (
        <div className={classNames(classes.ecWrapper)}>
          <ToastContainer />
          <ECHeaderComponent
            merchantContent={merchantContent}
            chainList={chainList}
            showShippingLayout={showShippingLayout}
            showSideBasket={showSideBasket}
            setShowSideBasket={setShowSideBasket}
            setShowShippingLayout={setShowShippingLayout}
            ecommerceContent={ecommerceContent}
            isEndsWithSlash={isEndsWithSlash}
            pagesContent={pagesContent}
          />
          {isEndsWithSlash && <MSubRoutesComponent contentType={"pages"} pagesContent={pagesContent} />}
          {!isEndsWithSlash && (
            <div className="ecProduct">
              {showShippingLayout ? (
                <ECAddressWrapperComponent
                  flowName={EcommerceFlow}
                  setShowShippingLayout={setShowShippingLayout}
                />
              ) : (
                <>
                  <div className="homebg">
                    {manageBgDetails(ecommerceContent.ecom_video_link)}
                  </div>
                  <div className="ec-front-content">
                    <h1>{ecommerceContent.ecom_title}</h1>
                    <p>{ecommerceContent.ecom_des}</p>
                  </div>
                  <ECProductComponent />
                </>
              )}
            </div>
          )}
          <ECFooterComponent />
        </div>
      )}
    </ >
  );
};

export default ECAdvanceComponent;
